import { getUrlForLocale } from '../helpers/convert';
import routeConfiguration from '../routing/routeConfiguration';
import { createResourceLocatorString } from './routes';

const SUPPORTED_LOCALES = ['en', 'el', 'de', 'ar'];

export const getLocaleFromPathname = pathname => {
  const match = pathname?.match(/^\/(en|el|de|ar)(?=\/|$)/);
  return match?.[1] || 'en';
};

export const getLocalizedRoutePath = (
  routeName,
  pathname = '/',
  params = {},
  searchParams = {}
) => {
  const basePath = createResourceLocatorString(
    routeName,
    routeConfiguration(),
    params,
    searchParams
  );

  return getUrlForLocale(basePath, getLocaleFromPathname(pathname));
};

export const navigateBackOrFallback = (history, fallbackPath) => {
  if (history?.length > 1) {
    history.goBack();
    return;
  }

  history.push(fallbackPath);
};

export const navigateBackOrRouteFallback = (
  history,
  pathname,
  routeName,
  params = {},
  searchParams = {}
) => {
  const fallbackPath = getLocalizedRoutePath(routeName, pathname, params, searchParams);
  navigateBackOrFallback(history, fallbackPath);
};
